<template>
  <a :href="market.website + '/'" class="site-logo" aria-label="Tapes To Digital home">
    <img :src="market.logo" alt="Tapes To Digital" class="site-logo-img" />
  </a>
</template>

<script>
import { market } from "@/utils/market";

// The real logo (HubSpot-hosted SVG), linking to the market's website
export default {
  data: () => ({ market }),
};
</script>

<style scoped>
.site-logo {
  display: flex;
  align-items: center;
  text-decoration: none;
}
.site-logo-img {
  display: block;
  height: 40px;
  width: auto;
  max-width: 220px;
}
@media (max-width: 599px) {
  .site-logo-img {
    height: 32px;
    max-width: 170px;
  }
}
</style>
